import SelectOptionItem from './SelectOptionItem/SelectOptionItem';

function SelectOption({
  items,
  selected,
  onClick,
  displayPrimaryButton,
  shouldDisplayPrice,
}) {
  const itemsMap = items.map((item, index) => {
    const isSelected = item.value === selected?.value;

    return (
      <SelectOptionItem
        key={index}
        data={item}
        selected={isSelected}
        onClick={() => onClick(item)}
        disabled={item.disabled}
        highlighted={item.highlighted}
        displayPrimaryButton={displayPrimaryButton}
        shouldDisplayPrice={shouldDisplayPrice}
      />
    );
  });

  return <div>{itemsMap}</div>;
}

export default SelectOption;
